// 防抖
export function debounce(fn, delay = 100) {
  let timer = null; // 记录上一次的延时器
  return function () {
    let args = arguments,
      that = this;
    // 清除上一次延时器
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(that, args);
    }, delay);
  };
}
// 节流
export function throttle(fn, delay = 100) {
  let lastTime = -delay;
  let timer = null;

  return function (...args) {
    const now = Date.now();
    if (now < lastTime) {
      lastTime = now - delay; // 重置状态
    }
    const remaining = now - lastTime;
    if (remaining >= delay) {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      lastTime = now;
      fn.apply(this, args);
    } else if (!timer) {
      timer = setTimeout(() => {
        lastTime = Date.now();
        timer = null;
        fn.apply(this, args);
      }, delay - remaining);
    }
  };
}
